var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('masked-input',{staticClass:"form-control seconds-as-time",attrs:{"mask":"111:11","placeholder-char":"0","placeholder":"HHH:mm"},model:{value:(_vm.compTotalTimeEntered),callback:function ($$v) {_vm.compTotalTimeEntered=$$v},expression:"compTotalTimeEntered"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }